import { render, staticRenderFns } from "./Right.vue?vue&type=template&id=7c46d9fa&scoped=true"
import script from "./Right.vue?vue&type=script&lang=js"
export * from "./Right.vue?vue&type=script&lang=js"
import style0 from "./Right.vue?vue&type=style&index=0&id=7c46d9fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c46d9fa",
  null
  
)

export default component.exports